import React, {useState, useEffect} from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {Form, Field} from 'react-final-form';
import {Panel} from "primereact/panel";
import {classNames} from 'primereact/utils';
import {InputText} from 'primereact/inputtext';
import {Button} from 'primereact/button';
import {Dropdown} from "primereact/dropdown";
import {InputSwitch} from "primereact/inputswitch";
import {BlockUI} from "primereact/blockui";
import {FileUpload} from "primereact/fileupload";
import {ProgressBar} from "primereact/progressbar";
import {InputMask} from "primereact/inputmask";
import {InputNumber} from "primereact/inputnumber";
import download from "js-file-download";
import axios from "axios";
import Cookies from "js-cookie";

import HelpComponent from "../HelpComponent";
import FormLocker from "../../util/FormLocker";

const _FM_EzeesettingsFormComponent = (props) => {

  const {t} = props;
  const navigate = useNavigate();
  const {id, action, entity} = useParams();
  const [formData, setFormData] = useState({
    channel_manager: "EZEE"
  });
  const [newFormData, setNewFormData] = useState({});
  const [accommodation, setAccommodation] = useState([]);
  const [categories, setCategories] = useState([]);
  const [roomTypes, setRoomTypes] = useState([]);
  const [ezeeUpdates, setEzeeUpdates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [locking, setLocking] = useState(false);

  const validate = (data) => {
    let errors = {};
    return errors;
  };
  const onSubmit = (data, form) => {
    setLoading(true)
    if (formData && formData.id) {
      axios.patch(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "accommodation/" + formData.id,
        newFormData,
        {
          params: {},
          headers: {
            'Authorization': 'Bearer ' + Cookies.get("userToken"),
            "Sys-name": Cookies.get("instanceId"),
            "Preferred-locale": Cookies.get("language")
          }
        })
        .then(response => {
          setFormData(response.data.data);
          setNewFormData({});
          window.App.toastShow('success', t('success'), response.data.message)
          setLoading(false)
          window.App.setState({
            rerenderAccommodationList: true,
          })
          if (props.closeForm === true) {
            navigate(-1)
          }
        })
        .catch(error => {
          setLoading(false)
          window.App.toastShow('error', t('error'), error.response.data.message, '', error.response)
        })
    }
    //form.restart();
  };
  //const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  //const isFormFieldValid = (meta) => !!(meta.error);
  const isFormFieldValid = (meta) => {
    if (loading) return false;
    return !!(meta.error);
  };
  const getFormErrorMessage = (meta) => {
    return isFormFieldValid(meta) && <small className="p-validate">{meta.error}</small>;
  };

  FormLocker(() => {
    if (formData && formData.id && formData._class_name) {
      window.App.formLock(formData._class_name, formData.id)
    }
  }, 1000);

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + Cookies.get("userToken"),
        "Sys-name": Cookies.get("instanceId"),
        "Preferred-locale": Cookies.get("language")
      }
    })
  }

  useEffect(() => {
    setLoading(true);
    axios({
      method: 'get',
      url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "accommodation",
      params: {},
      headers: {
        'Authorization': 'Bearer ' + Cookies.get("userToken"),
        "Sys-name": Cookies.get("instanceId"),
        "Preferred-locale": Cookies.get("language")
      }
    })
      .then(response => {
        setAccommodation(response.data.data.items);
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
    if (props.accommodationId) {
      apiCall('get', 'accommodation/' + props.accommodationId)
        .then(response => {
          setFormData(response.data.data);
          setLoading(false)
        })
        .catch((error) => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
    }
  }, [props.accommodationId, window.App.state.rerenderEzeesettingsForm]);

  return (
    <>
      <BlockUI blocked={locking} className="blocked-ui-overlay" template={<div className="blocked-ui-message"><i className="pi pi-exclamation-triangle blocked-ui-message-icon" aria-hidden="true"></i>{t("module_editing_after_save_only")}</div>}>
        <Form onSubmit={onSubmit} initialValues={formData}
              validate={validate} render={({handleSubmit}) => (
          <form onSubmit={handleSubmit} className="">
            <Panel>
              {loading &&
                <ProgressBar mode="indeterminate"
                             style={{height: '5px', position: 'fixed', top: 0, zIndex: 9}}></ProgressBar>
              }
              <div className={"p-grid"}>
                <div className={"p-col"}>
                  <h2 className={"p-m-0"}>{t('ezee_settings')}</h2>
                </div>
                <div className={"p-col p-text-right p-col-align-center"}>
                  <Button type="button" aria-label={t('save')} icon={"pi pi-save"}
                          loading={loading}
                          onClick={() => {
                            props = {...props, closeForm: false}
                            onSubmit()
                          }}
                          className="p-button-success p-ml-2"/>
                </div>
              </div>
              {/*<HelpComponent type={"site"} position={"IN_ACTIVE_BOX"}/>*/}
              <HelpComponent type={"tab"} tabNumber={1}/>
              <div className={"p-grid"}>
                <div className={"p-col-12 p-lg-6"}>
                  <div className="p-field p-fluid">
                    <label htmlFor="accommodation">{t('accommodation')}</label>
                    <Dropdown  options={accommodation}
                              className={"w-100"}
                              optionLabel="name"
                              optionValue="id"
                              filter
                              disabled={loading}
                              id={"accommodation"}
                              emptyMessage={t('empty_message')}
                              onChange={(e) => {
                                props.onAccommodationChange(e.value)
                              }}
                              value={Number(props.accommodationId)}
                    />
                  </div>
                </div>
              </div>
              <div className={"p-grid"}>
                <div className={"p-col-12 p-lg-6"}>
                  <Field name="ezee_centrtix_update_mode" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <HelpComponent type={"field"} field={"ezee_centrtix_update_mode"}/>
                      <label htmlFor="ezee_centrtix_update_mode"
                             className={classNames({'p-error': isFormFieldValid(meta)})}>{t('ezee_centrtix_update_mode')}</label>
                      <span className="p-d-block">
                        <Dropdown  options={ezeeUpdates}
                                  filter
                                  optionLabel={(option) => window.App.getTranslatedLabel(option.key)}
                                  optionValue="value"
                                  id={"ezee_centrtix_update_mode"}
                                  emptyMessage={t('empty_message')}
                                  onChange={(e) => {
                                    setFormData({
                                      ...formData,
                                      ezee_centrtix_update_mode: e.value
                                    })
                                    setNewFormData({
                                      ...newFormData,
                                      ezee_centrtix_update_mode: e.value
                                    })
                                  }}
                                  value={formData.ezee_centrtix_update_mode}
                        />
                      </span>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}/>
                </div>
                <div className={"p-col-12 p-lg-12 p-xl-12"}>
                  <Field name="e_zee_centrix_hotel_code" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <HelpComponent type={"field"} field={"e_zee_centrix_hotel_code"}/>
                      <label htmlFor="e_zee_centrix_hotel_code"
                             className={classNames({'p-error': isFormFieldValid(meta)})}>{t('ezee_centrix_hotel_code')}</label>
                      <span className="p-d-block">
                      <InputText id="e_zee_centrix_hotel_code" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     e_zee_centrix_hotel_code: e.target.value
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     e_zee_centrix_hotel_code: e.target.value
                                   })
                                 }}
                                 value={formData.e_zee_centrix_hotel_code}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}/>
                </div>
                <div className={"p-col-12 p-lg-12 p-xl-12"}>
                  <Field name="e_zee_centrix_auth_key" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <HelpComponent type={"field"} field={"e_zee_centrix_auth_key"}/>
                      <label htmlFor="e_zee_centrix_auth_key"
                             className={classNames({'p-error': isFormFieldValid(meta)})}>{t('ezee_centrix_auth_key')}</label>
                      <span className="p-d-block">
                      <InputText id="e_zee_centrix_auth_key" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     e_zee_centrix_auth_key: e.target.value
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     e_zee_centrix_auth_key: e.target.value
                                   })
                                 }}
                                 value={formData.e_zee_centrix_auth_key}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}/>
                </div>
              </div>
            </Panel>
          </form>
        )}/>

      </BlockUI>
      {locking === true &&
        <div className={"p-mt-2"}>
          <i className={"pi pi-exclamation-circle"}></i>
          &nbsp;
          {t('form_under_edit')}
          {formData && formData.under_edit_by_name_snap &&
            <>&nbsp;{t('form_under_edit_by')}: {formData.under_edit_by_name_snap}</>
          }
        </div>
      }
    </>
  )
}
export default withTranslation('common')(_FM_EzeesettingsFormComponent);
